<template>
  <div>
    <AdminMigrationModal
      v-model="dialog"
      :menu-key="menuKey"
      @close="handleClose"
    />
  </div>
</template>

<script>
import AdminMigrationModal from '@/components/AdminMigrationModal.vue';
import {
  getMigratedMenuConfig,
  MIGRATED_MENU_KEYS,
} from '@/helpers/migratedMenus';

export default {
  name: 'UrlTools',
  components: {
    AdminMigrationModal,
  },
  data () {
    return {
      dialog: true,
      menuKey: MIGRATED_MENU_KEYS.URL_TOOLS,
    };
  },
  methods: {
    handleClose () {
      const menuConfig = getMigratedMenuConfig(this.menuKey);

      if (this.$route.path === menuConfig.route) {
        this.$router.push({ path: '/dashboard' });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Contents/UrlTools/UrlTools.vue